import React from 'react';
import Styled from 'styled-components';
import * as color from './colors';
import Button from './common/button';

const Heading = Styled.h1`
text-align:center;
font-size: 5rem;
`;

const Paragraph = Styled.p`
margin-bottom: 3rem;
`;

const Section = Styled.section`
background-color: ${color.tertiary};
height: 100vh;
display: flex;
align-items:center;
justify-content: center;
flex-direction: column;
color: ${color.primary};
`;

function NotFound() {
  return (
    <React.Fragment>
      <Section>
        <Heading>We can't find this page!</Heading>
        <Paragraph>
          Hello there! the page you're trying to visit <strong>can't be found</strong> or <strong>has not been
          created yet.</strong>
        </Paragraph>
        <Button link={{path: "/"}} text={'Go back home'} type={'primary'} rounded />
      </Section>
    </React.Fragment>
  );
}

export default NotFound;
